import { axios } from '@/utils/request';

let Api = {
  addUser: '/user/add', // 注册 申请试用账号
};

// 注册 申请试用账号
export const addUserApi = (params) => {
  return axios.post(Api.addUser,  params);
};
